import React, { useState, useEffect, useRef } from "react";
import "./ImageStyle.css";

export default function Gallery(props) {
  const Images = props.galleryData ? props.galleryData.flatMap(Object.values) : [];
  const youtubeIds = props.youtubeIds || [];
  const [selectedImg, setSelectedImg] = useState(props.thumbnail);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [videoModal, setVideoModal] = useState(null);

  useEffect(() => {
    setSelectedImg(props.thumbnail);
  }, [props.thumbnail]);

  // Stäng popup när filmen är slut
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://www.youtube.com") return;
      try {
        const data = JSON.parse(event.data);
        if (data.event === "onStateChange" && data.info === 0) {
          setVideoModal(null);
        }
      } catch (e) {}
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className="App">
      <div className="container">
        <img
          src={`/.${selectedImg}`}
          alt="Selected"
          className="selected"
          onClick={() => setLightboxOpen(true)}
          style={{ cursor: "zoom-in" }}
        />
        <div className="imgContainer">
          {Images.map((img, index) => (
            <div className="more_img" key={index}>
              <img
                src={`/.${img}`}
                alt={`Gallery image ${index + 1}`}
                onClick={() => setSelectedImg(img)}
              />
            </div>
          ))}

          {/* YouTube thumbnails */}
          {youtubeIds.map((ytId, index) => (
            <div
              className="more_img video-thumb"
              key={`yt-${index}`}
              onClick={() => setVideoModal(ytId)}
            >
              <img
                src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`}
                alt={`Video ${index + 1}`}
              />
              <div className="play-icon">▶</div>
            </div>
          ))}
        </div>
      </div>

      {/* Bild lightbox */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={() => setLightboxOpen(false)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setLightboxOpen(false)}>✕</button>
            <img src={`/.${selectedImg}`} alt="Lightbox" className="lightbox-img" />
          </div>
        </div>
      )}

      {/* Video popup */}
      {videoModal && (
        <div className="lightbox-overlay" onClick={() => setVideoModal(null)}>
          <div className="lightbox-content video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setVideoModal(null)}>✕</button>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${videoModal}?autoplay=1&enablejsapi=1`}
              title="YouTube video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
        </div>
      )}
    </div>
  );
}